import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import {
  MainNavbar,
  MainUserContent,
  MainIconContainer,
  MainDropdown,
  MainDropdownMenu,
  MainMenuItem,
  Logo,
  MainIcon,
  HeaderStyles,
} from "./HeaderStyles";
import CheckRender from "../Common/CheckRender";
import { UserOutlined, LogoutOutlined, DownOutlined } from "@ant-design/icons";
import Colors from "../../themes/Colors";
import useEmpresa from "../../hooks/useEmpresa";
import { EMPRESA } from "../../utils/Constant";
import Text from "../Common/Text";
import ModalInformacionPrestador from "./ModalInformacionPrestador";

const CustomMainNavBar = (props) => {
  const { isLoginScreen } = props;

  const { prestador } = props?.authUserData;

  const empresa = useEmpresa();

  const [menuVisible, setMenuVisible] = useState(false);
  const [userMenuVisible, setUserMenuVisible] = useState(false);
  const [showModalInformacion, setShowModalInformacion] = useState(false);

  const menuRef = useRef(null);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenuVisible(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const dimensionLogo =
    empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO
      ? HeaderStyles.dimensionLogoPrimera
      : HeaderStyles.dimensionLogoHumano;

  return (
    <MainNavbar backGroundColor={empresa?.COLOR_PRINCIPAL}>
      <div>
        <a href={"/"}>
          <Logo
            src={empresa?.LOGO_BLANCO}
            width={dimensionLogo.width}
            height={dimensionLogo.height}
            alt="Logo"
          />
        </a>
      </div>

      <div>
        <MainIconContainer>
          <CheckRender allowed={!isLoginScreen}>
            <MainIcon>
              <MainDropdown ref={userMenuRef}>
                <UserOutlined
                  style={{
                    color: Colors.white,
                    fontSize: 25,
                    cursor: "pointer",
                    marginRight: "5px",
                  }}
                  onClick={() => setUserMenuVisible(!userMenuVisible)}
                />
                <MainUserContent font={empresa?.LETRA_PRINCIPAL}>
                  {prestador?.nombre}
                </MainUserContent>
                <DownOutlined
                  style={{
                    color: Colors.white,
                    fontSize: 16,
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() => setUserMenuVisible(!userMenuVisible)}
                />
                <CheckRender allowed={userMenuVisible}>
                  <MainDropdownMenu backGroundHover={empresa?.COLOR_PRINCIPAL}>
                    <MainMenuItem
                      onClick={(e) => {
                        e.preventDefault();
                        setShowModalInformacion(true);
                        setUserMenuVisible(false);
                      }}
                      font={empresa?.LETRA_PRINCIPAL}
                      style={{ cursor: "pointer" }}
                      href="#"
                    >
                      <Text
                        size="15px"
                        color={Colors.primaryPrimera}
                        hoverColor={Colors.white}
                      >
                        Ver información
                      </Text>
                    </MainMenuItem>
                  </MainDropdownMenu>
                </CheckRender>
              </MainDropdown>
            </MainIcon>
            <MainIcon>
              <MainDropdown ref={menuRef}>
                <LogoutOutlined
                  style={{ color: Colors.white, fontSize: 25, cursor: "pointer" }}
                  onClick={() => setMenuVisible(!menuVisible)}
                />
                <CheckRender allowed={menuVisible}>
                  <MainDropdownMenu backGroundHover={empresa?.COLOR_PRINCIPAL}>
                    <MainMenuItem
                      href="/confirmacion"
                      font={empresa?.LETRA_PRINCIPAL}
                    >
                      <Text
                        size="15px"
                        color={Colors.primaryPrimera}
                        hoverColor={Colors.white}
                      >
                        Cerrar Sesión
                      </Text>
                    </MainMenuItem>
                  </MainDropdownMenu>
                </CheckRender>
              </MainDropdown>
            </MainIcon>
          </CheckRender>
        </MainIconContainer>
      </div>

      <ModalInformacionPrestador
        isOpen={showModalInformacion}
        onClose={() => setShowModalInformacion(false)}
        prestador={prestador}
      />
    </MainNavbar>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CustomMainNavBar);
